/** @module Camunda/ProcessDefinitionPrimaryTypeRenderer */
define([
    "dojo/_base/declare",
    "csi/heading/StringSelection",
    "csi/locale",
    "csi/reflection",
    "csi/store/Classes",
    "./main"
], function(declare,StringSelection,locale,reflection,ClassesStoreFactory,Camunda) {

    /**
     * Create a store of all primary domain classes
     */
    function createStore() {
        return ClassesStoreFactory(reflection.getClasses(),
                Camunda.isValidClass,
                function(rc, item) {
                    item.name += ' (' + rc.getType() + ')';
                }
            );
    }

    return declare(StringSelection, {
        /**
         * @override
         * Return the localized type name
         */
        formatValue: function(value, fmt) {
            return locale.type(value);
        },

        /**
         * @override
         * Return attribute value from edit control
         */
        fromHtmlDynamic: function(ctx, h, editNode) {
            return editNode.get("value");
        },

        /**
         * @override
         * Return a store of primary domain classes
         */
        getStore: function(ctx, h, value, bAll) {
            return createStore();
        }
    });
});
